/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by kyang on 6/19/19.
 */

function AttachmentSelectModalController(
    this: JS5Object,
    _: JS5Object,
    $q: JS5Object,
    $filter: JS5Function) {

    //======//
    // Grid //
    //======//

    const colDefs: JS5Object[] = [
        {
            cellTemplate: 'components/visual/grid/check-mark-template.html',
            enableColumnMenu: false,
            enableSorting: false,
            enableColumnResizing: false,
            field: 'checkMark',
            fieldName: 'Selection',
            headerCellTemplate: 'components/grids/default-artwork-maps-grid/cell-templates/header-check-mark-row-count-template.html',
            width: 55,
        },
        {
            cellTemplate: 'components/visual/grid/base-tooltip-template.html',
            enableColumnMenu: false,
            enableSorting: true,
            field: 'sourceMediaAcceptProfile.name',
            displayName: 'Media Accept Profile',
        },
        {
            cellTemplate: 'system/templates/mediaAcceptProfiles/searchView/renderers/accept-profile-tooltip-template.html',
            enableColumnMenu: false,
            enableSorting: true,
            field: 'sourceMediaAcceptProfile.type',
            displayName: 'Type',
        }
    ];

    this.gridOptions = {
        selectionRowHeaderColName: 'Selection',
        rowSelection: true,
        multiSelect: true,
        enableFullRowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: true,
        enableColumnResizing: false,
        enableHorizontalScrollbar: 0,
        enableVerticalScrollbar: 2,
        enablePaginationControls: false,
        enableSorting: true,
        rowHeight: 26,
        minRowsToShow: 5,
        columnDefs: colDefs,
        data: [],
        onRegisterApi: (gridApi: JS5Object) => {
            this.gridApi = gridApi;
        }
    };

    this.areAllRowsSelected = () => {
        return this.gridApi.selection.getSelectedCount() === this.gridOptions.data.length;
    };

    this.onSelectAllToggled = () => {
        if (this.areAllRowsSelected()) {
            this.gridApi.selection.clearSelectedRows();
        } else {
            this.gridApi.selection.selectAllRows();
        }
    };


    //===================//
    // Template Bindings //
    //===================//

    this.disableOKButton = () => {
        return this.gridApi.selection.getSelectedCount() < 1;
    };

    this.onOK = () => {
        this.close({$value: this.gridApi.selection.getSelectedRows()});
    };

    this.cancel = () => {
        this.dismiss({$value: 'cancel'});
    };

    this.executeSearch = (searchText: string) => {
        // Case is handled by the filter to make case insensitive searches
        let searchFields = ['sourceMediaAcceptProfile.name', 'type', 'targetPathExpression'];
        this.gridOptions.data = $filter('gridSearch')(this.resolve.availableDeliveryItems, searchText, searchFields);
    };

    //=================//
    // Lifecycle Hooks //
    //=================//

    this.$onInit = () => {
        this.gridOptions.data = _.clone(this.resolve.availableDeliveryItems);
    };
}

angular
    .module('prism-ui.components')
    .component(
        'attachmentSelectModal',
        {
          controller: AttachmentSelectModalController,
          templateUrl: 'components/modal/email-attachment-modal/email-attachment-modal-template.html',
          bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
          }
        }
    );
